export const translations = {
  main: {
    errorBoundary: {
      errorOccurred: 'حدث خطأ أثناء معالجة المدفوعات.',
    },
  },
  notfound: {
    notFound: {
      code404: '404 غير موجود',
    },
  },
  currency: {
    AED: 'د.إ',
    SAR: 'ر.س.',
  },
  price: '{currency} {amount, number}',
  checkout: {
    summary: {
      paymentSummary: 'ملخص الدفع',
      subtotal: 'المجموع الفرعي',
      discount: 'خصم',
      discountPrice: '- <price/>',
      tips: 'الإكرامية',
      serviceFee: 'رسوم الخدمة',
      totalAmount: 'المبلغ الإجمالي',
    },
    splitBillInfo: {
      splitByVar: 'تم تقسيم الفاتورة بالتساوي بين {numberOfSplits} من الأشخاص',
      splitByItems: 'تم تقسيم الفاتورة حسب العناصر',
    },
    splitEqualMode: {
      peopleOnTable: 'كم عدد الموجودين على الطاولة؟',
      payingFor: 'كم عدد الأشخاص الذين ستدفع لهم؟',
      leftToPay: 'المبلغ المتبقي على الآخرين دفعه',
      yourShare: 'نصيبك',
      removeSplit: 'إزالة التقسيم',
      confirm: 'تاكيد',
    },
    splitByItems: {
      title: 'ادفع ثمن مشترياتك',
      leftToPay: 'يُترك للدفع',
      yourShare: 'حصتك',
      removeSplit: 'إزالة الانقسام',
      confirm: 'تأكيد',
      noItems: 'لا توجد عناصر قابلة للتقسيم',
      back: 'رجوع',
      conflictAlert: 'بعض المنتجات تم دفع ثمنها للتو من قبل شخص آخر - يرجى مراجعة اختيارك',
    },
    paymentsErrorBoundary: {
      errorOccurred: 'حدث خطأ أثناء معالجة المدفوعات.',
    },
    tipChip: {
      custom: 'مخصص',
      mostCommon: 'الأكثر شيوعًا',
      noThanks: 'لا شكرا',
      percentage: '%{percentage}',
    },
    withAmountDebounce: {
      loading: 'جاري التحميل...',
    },
    tips: {
      tipServer: 'أعطِ بقشيشًا للنادل',
      tipGoesToServer: '%100 من إكراميتك ستذهب إلى النادل الخاص بك',
    },
    splitSummary: {
      splitSummary: 'كافئ النادل بإكرامية',
      totalBill: 'إجمالي الفاتورة',
      yourShare: 'حصتك',
    },
    splitBill: {
      splitEqually: 'تقسيم بالتساوي',
      splitBill: 'تقسيم الفاتورة',
      editSplit: 'تعديل الانقسام',
      payForItems: 'ادفع ثمن مشترياتك',
      payForItemsUnavailable: 'غير متاح للطلبات التي تحتوي على منتجات التبغ',
      select: 'اختر',
      back: 'رجوع',
    },
    checkoutController: {
      payments: 'المدفوعات',
      splitExpired: 'انتهت صلاحية دفعاتك المقسمة',
      orderNumberVar: 'رقم الطلب: {orderNumber}',
      remainingAmountVar: 'المبلغ المتبقي: {remainingAmount}',
      contactRestaurant: 'يرجى الاتصال بالمطعم لدفع فاتورتك',
    },
    serviceFeeInfo: {
      serviceFee: 'رسوم الخدمة',
      feeDescription:
        'تغطي الرسوم راحة استخدام مدفوعات رمز الاستجابة السريعة (QR Code) وهي طريقة آمنة وسريعة وسلسة لدفع فاتورتك مع الاستفادة الإضافية من تقسيمها مع الآخرين.',
      gotIt: 'فهمتها',
    },
    customTip: {
      customTip: 'إكرامية  مخصصه',
      aedLabel: 'د.إ',
      sarLabel: 'ر.س.',
    },
    infoAlert: {
      billUpdated: 'تم تحديث فاتورتك، يرجى مراجعتها والمتابعة مرة أخرى',
      splitCreationFailed: 'تعذّر إعداد التقسيم. يرجى المحاولة مرة أخرى.',
    },
    summaryRow: {
      infoIcon: 'أيقونة المعلومات',
    },
    increaseDecreaseNumber: {
      minus: 'ناقص',
      plus: 'بالإضافة إلى',
      decrease: 'انخفاض',
      increase: 'زيادة',
    },
    bill: {
      yourOrder: 'طلبك',
      collapseIcon: 'رمز التصغير',
      quantity: 'x{quantity}',
      modifierQuantity: ' (x{quantity})',
    },
  },
  menu: {
    addToCart: 'أضف إلى السلة',
    orderPromptModal: {
      title: 'هل تريد الطلب من طاولتك؟',
      description:
        'قم بتنزيل تطبيقنا اليوم واحصل على ما يصل إلى {cashbackPercentageValue}% استرداد نقدي واستمتع بالعروض الحصرية واطلب مباشرة من مقعدك.',
      downloadApp: 'تنزيل التطبيق',
    },
    itemCardCashbackPill: {
      earnCashback: {
        AED: 'اكسب درهمًا إماراتيًا',
        SAR: 'اكسب ريالًا سعوديًا',
      },
      kitopi: 'كيتوبي',
    },
    brandPresentation: {
      table: 'طاولة',
      menu: 'القائمة',
    },
    entry: {
      tableVar: 'الجدول {tableNumber}',
      payNow: 'ادفع الآن',
      viewMenu: 'عرض القائمة',
      signUpBonus: {
        firstLine: 'سجل',
        secondLine: 'مكافأة',
      },
      bonusTooltipWithBonus:
        '{bonusValue} {currency} اليوم و<br/> ما يصل إلى {cashbackPercentageValue}% استرداد نقدي <br/> على كل طلب',
      bonusTooltipWithoutBonus: 'استرداد نقدي يصل إلى {cashbackPercentageValue}% على كل طلب',
      promoWithMinimumSpend: '{minimumSpend} {currency} الحد الأدنى للإنفاق',
      termsConditionsApply: 'تطبق الشروط والأحكام',
    },
    itemDetailsSkeleton: {
      close: 'إغلاق',
    },
    itemDetails: {
      close: 'إغلاق',
      required: 'مطلوب',
      optional: '{maximumSelectedElements} اختياري • حتى ',
      allergens: 'مسببات الحساسية',
    },
  },
  paymentConfirmation: {
    successTitle: {
      paymentSuccessful: 'تم الدفع بنجاح',
      youveEarned: 'لقد كسبت',
      signupBonus: 'مكافأة التسجيل',
      useAcross: 'استخدمه في أكثر من 200 مطعم لتناول الطعام في المطعم أو التوصيل',
      kitopi: 'كيتوبي',
      getUpToXCashback: {
        firstLine: 'احصل على ما يصل إلى {cashbackPercentageValue}%',
        secondLine: 'استرداد نقدي',
      },
    },
    streak: {
      startYourStreak: 'ابدأ سلسلتك!',
    },
    countDown: {
      timeToClaimCashback: 'الوقت المتبقي للمطالبة باسترداد أموالك',
    },
    paymentConfirmation: {
      downloadApp: 'قم بتنزيل التطبيق للمطالبة Kitopi',
      downloadKitopiApp: 'تنزيل تطبيق كيتوبي',
      troubleDownloading: 'هل تواجه مشكلة في التنزيل؟ انقر على الرمز لنسخ الرابط.',
      copied: 'تم النسخ!',
      failedToCopy: 'فشل النسخ',
      askForReceipt: 'اطلب من النادل إيصالًا',
      cashbackWithKitopi: 'احصل على استرداد نقدي مع تطبيق Kitopi',
      cashbackWhenPay: 'احصل على استرداد نقدي عند الدفع في التطبيق',
      copy: 'نسخ',
      copyLink: 'نسخ الرابط',
      hopeYouEnjoyed: {
        firstLine: 'نتمنى انك',
        secondLine: 'استمتعت ',
        thirdLine: 'بوجبتك',
      },
    },
  },
  paymentFailure: {
    paymentFailure: {
      paymentFailed: 'فشل الدفع',
      sorryUnsuccessful: 'عذرًا، لم يتم إتمام عملية الدفع',
      billUnpaid: 'فاتورة غير مدفوعة',
    },
  },
  cashbackBanner: {
    cashbackBannerController: {
      getCashbackInApp: 'احصل على استرداد نقدي عند الدفع في التطبيق',
      getCashbackWithKitopi: 'احصل على استرداد نقدي مع تطبيق Kitopi',
    },
    cashbackIcon: 'رمز الاسترداد النقدي',
    closeIcon: 'رمز الإغلاق',
  },
  rewards: {
    kitopiCoinSmall: 'عملة كيتوبي الصغيرة',
    earnWithSignupBonus: 'سوف تربح {currency} <amount/> مكافأة التسجيل',
    earnWithOrder: 'سوف تربح {currency} <amount/> مع هذا الطلب',
    excludesTobacco: 'لا يشمل منتجات التبغ',
  },
  sharedButton: {
    logo: 'شعار',
  },
  bottomSheet: {
    close: 'خفض',
  },
  brandHeader: {
    back: 'العودة',
    star: 'نجمة',
    goBack: 'العودة',
    search: 'ابحث',
    seeLess: 'اعرض أقل',
    seeMore: 'اعرض أكثر',
  },
  languageSwitcher: {
    language: 'اللغة',
    switchTo: 'التبديل إلى {language}',
  },
  viewSwitcher: {
    gridView: 'عرض الشبكة',
    listView: 'عرض القائمة',
    switchToListView: 'التبديل إلى عرض القائمة',
    switchToGridView: 'التبديل إلى عرض الشبكة',
  },
  menuCategories: {
    jumpTo: 'تنقل إلى',
  },
  infoAlert: {
    infoIcon: 'رمز المعلومات',
  },
  noBill: {
    restaurant: 'مطعم',
    looksLikeNoOrder: 'يبدو أنك لم تطلب بعد',
    billWillAppear: 'ستظهر فاتورتك عند طلبك',
    downloadAppCashback:
      'قم بتنزيل التطبيق واحصل على ما يصل إلى {cashbackPercentageValue}% استرداد نقدي بعد وجبتك!',
    downloadKitopiApp: 'تنزيل تطبيق كيتوبي',
  },
  terms: {
    fullMessage:
      'عند استخدامك {domain} فإنك تقبل <termsLink>الشروط والأحكام</termsLink> و<privacyLink>سياسة الخصوصية</privacyLink> الخاصة بنا.',
  },
  successSummary: {
    loading: 'تحميل ...',
    partiallyPaid: 'مدفوعة جزئيا',
    fullyPaid: 'مدفوع كليا',
    tableDineIn: 'طاولة تناول الطعام {tableNumber}',
    counterNumber: 'رقم العداد {counterNumber}',
    tipAmount: 'مبلغ الاكراميه',
    serviceFee: 'رسوم الخدمة',
    youPaid: 'لقد دفعت',
  },
};
